import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the CarialacakdekontPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carialacakdekont',
  templateUrl: 'carialacakdekont.html',
})
export class CarialacakdekontPage {
  vwCari:any={};
  Cari:any={ID: -1, Definition_: "", CariKartID: "",};
  CariHareket = { ID: -1, CariKartID: "", IslemTuru: 2, Sign: 0, Tutar: "", SlsMan: "mobil", Text: "Dekont ile Alacaklandır",}
aktifKullanici:any;

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams)
     
      {
    if (navParams.get("vwCari") != null) {
      this.vwCari = navParams.get("vwCari");

      var data = new FormData();
      data.append("cari_id", this.vwCari.ID);
    

      this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.Cari = Sonuc.SonucObject;
        this.CariHareket.CariKartID = this.Cari.ID;
     
        

      }
      )
    }
    this.aktifKullanici = this.ortak.storagePersonelGetir.Name

  }

  ionViewDidLoad() {
 
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.CariHareket.Tutar == null || this.CariHareket.Tutar == "") {
      mesaj = mesaj + "Lütfen geçerli bir Tutar  giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();

    this.CariHareket.SlsMan=this.aktifKullanici;
    formData.append("CariTah_json", JSON.stringify(this.CariHareket));

    this.bllOrtak.islem(formData, "CariDekont", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      if(sonuc.Sonuc==99) console.log(sonuc.Exception);
      

    })


  }
  

}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/carialacakdekont/carialacakdekont.ts